<template>
  <div class="circle">
    <svg
      :width="outerCircleDiameter"
      :height="outerCircleDiameter"
      class="circle__svg"
    >
      <circle
        :cx="outerCircleRadius"
        :cy="outerCircleRadius"
        :r="radius"
        class="circle__progress circle__progress--path"
        :style="{ strokeWidth: strokeWidth, stroke: strokeColor }"
      />
      <circle
        :cx="outerCircleRadius"
        :cy="outerCircleRadius"
        :r="radius"
        class="circle__progress circle__progress--fill"
        :style="fillStyle"
      />
    </svg>
    <div class="circle__desc">
      {{ progress }}%
    </div>
  </div>
</template>

<script>
export default {
  props: {
    radius: {
      type: Number,
      default: 10
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeColor: {
      type: String,
      default: '#007aff'
    },
    progress: {
      type: Number,
      required: true
    }
  },
  computed: {
    outerCircleRadius () {
      return this.radius + this.strokeWidth
    },
    outerCircleDiameter () { // 外圆的直径
      return (this.radius + this.strokeWidth) * 2
    },
    circumference () { // 周长
      return 2 * Math.PI * this.radius
    },
    offset () { // 偏移量
      return (100 - this.progress) / 100 * this.circumference
    },
    fillStyle () {
      return {
        '--strokeLength': this.circumference,
        strokeWidth: this.strokeWidth,
        stroke: this.strokeColor,
        strokeDashoffset: this.offset
      }
    }
  }
}
</script>

<style lang="less" scoped>
.circle {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.circle__svg {
  transform: rotate(-90deg);
}

.circle__progress {
  fill: none;
  stroke-opacity: 0.3;
  stroke-linecap: round;
}

.circle__progress--fill {
  --strokeLength: 0;
  stroke-opacity: 1;
  stroke-dasharray: var(--strokeLength);
}

.circle__desc {
  margin-left: 8px;
  font-size: 12px;
}
</style>
